export const companyInfo = {
  name: "TEV Africa Foods",
  tagline: "Nourishing Africa's Future",
  description: "Leading Africa's food security mission through sustainable farming, quality processing, and regional excellence across Southern and East Africa.",
  mission: "To leverage our resources and capabilities to contribute towards food security at the local, national and regional level, in a manner that is sustainable.",
  vision: "To attain scale and market leadership in our value chains, which would allow us to contribute effectively and meaningfully to the realization of a better world for our communities.",
  logo: "/images/Tev-Africa-Foods-Legacy-Logo-300x295 (1).png"
};

export const coreValues = [
  {
    title: "Respect & Support",
    description: "We respect, support and value our people",
    icon: "Users"
  },
  {
    title: "Excellence",
    description: "Going the extra mile for customers and partners",
    icon: "Award"
  },
  {
    title: "Innovation",
    description: "Thinking outside the box in all we do",
    icon: "Lightbulb"
  },
  {
    title: "Community Care",
    description: "Caring for communities and natural environment",
    icon: "Heart"
  },
  {
    title: "Long-term Value",
    description: "Delivering sustainable long-term value",
    icon: "TrendingUp"
  },
  {
    title: "Integrity",
    description: "Leadership and integrity in all dealings",
    icon: "Shield"
  }
];

export const statistics = [
  { value: "2,200+", label: "Hectares of Farmland" },
  { value: "3", label: "Countries Operating" },
  { value: "150MT", label: "Weekly Processing Capacity" },
  { value: "50+", label: "Outgrower Partners" }
];

export const newsArticles = [
  {
    id: 1,
    category: "Expansion",
    title: "New Outgrower Schemes Launching in 2026",
    description: "TEV Foods plans to launch new outgrower schemes in Dedza, Kasungu and Mangochi districts in 2026, expanding our farmer partnership network and increasing agricultural productivity across Malawi.",
    date: "December 2024",
    icon: "Expand"
  },
  {
    id: 2,
    category: "Innovation",
    title: "SAH Technology for Rapid Cassava Multiplication",
    description: "Our new Semi-Autotrophic Hydroponics site at Chankhandwe Farm will enable rapid multiplication of improved cassava varieties, revolutionizing our seed production capabilities.",
    date: "December 2024",
    icon: "Seedling"
  },
  {
    id: 3,
    category: "Partnership",
    title: "Strengthening Research Collaborations",
    description: "Continued partnerships with IITA, CIAT and ICRISAT ensure access to latest research and best practices in seed multiplication and agricultural innovation.",
    date: "December 2024",
    icon: "Handshake"
  }
];

export const sbus = [
  {
    id: 1,
    title: "Agronomy",
    description: "Seed production, irrigation services, and commercial farming operations",
    icon: "Seedling",
    companies: [
      "TEV Irrigation & Farm Services Ltd",
      "Mpatsa-TEV Farms Ltd",
      "TEV Agro Limitada (Mozambique)"
    ]
  },
  {
    id: 2,
    title: "Value Addition",
    description: "Agroprocessing and value addition of agricultural products",
    icon: "Factory",
    companies: [
      "TEV Africa Foods Ltd",
      "Processing facility in Lilongwe",
      "Quality assurance systems"
    ]
  },
  {
    id: 3,
    title: "Trading",
    description: "Domestic and international trading operations",
    icon: "Globe",
    companies: [
      "Export focus",
      "Regional market coverage",
      "Quality compliance"
    ]
  }
];

export const products = {
  semiProcessed: [
    {
      name: "Common Beans",
      description: "Red speckled, NUA 45 and white haricot varieties",
      icon: "Leaf"
    },
    {
      name: "Raw Peanut Kernels",
      description: "Chalimbana, CG9, CG10 and other varieties",
      icon: "Circle"
    }
  ],
  valueAdded: [
    {
      name: "Roasted & Blanched Nuts",
      description: "Premium quality roasted peanuts",
      icon: "Fire"
    },
    {
      name: "Peanut Butter",
      description: "High-quality peanut butter for local and export markets",
      icon: "Jar"
    }
  ]
};

export const partnerships = [
  {
    name: "The Alliance of Bioversity International and CIAT",
    description: "Research partnership for common beans development and improvement",
    icon: "Microscope"
  },
  {
    name: "International Institute of Tropical Agriculture (IITA)",
    description: "Collaboration for cassava research and development",
    icon: "Flask"
  },
  {
    name: "ICRISAT",
    description: "Partnership for peanuts research and development",
    icon: "Dna"
  }
];

export const contactInfo = {
  address: "Plot No. 21/2/27B, Chitipi | Off Mchinji Road | P.O. Box 30748 | Lilongwe 3, Malawi",
  email: "mw@tevafricafoods.com",
  phone: "+265 999 956 459 / +265 888 368 871",
  website: "www.tevafricafoods.com"
};
